<template>
  <div>
    <b-row v-if="show" class="no-gutters">
      <b-col class="d-flex justify-content-end shadow p-3">
        <template v-if="hasUserWritePermission">
          <b-button v-if="spaceplan.isEditModeEnabled" variant="primary" class="ml-3"
                    @click="addSpacePlanItemClicked">
            <font-awesome-icon icon="plus" />
            {{ $t('add-service-or-device') | capitalize }}
          </b-button>
          <b-button v-if="spaceplan.isEditModeEnabled" variant="primary" class="ml-3"
                    @click="editSpacePlanClicked">
            <font-awesome-icon icon="pen" />
            {{ $t('edit') | capitalize }}
          </b-button>
          <b-button v-if="spaceplan.isEditModeEnabled" variant="primary" class="ml-3"
                    @click="shareClicked">
            <font-awesome-icon icon="share-alt" />
            {{ $t('share') | capitalize }}
          </b-button>
          <b-button v-if="spaceplan.isEditModeEnabled" variant="danger" class="ml-3"
                    @click="removeSpacePlanClicked">
            <font-awesome-icon icon="trash-alt" />
            {{ $t('remove-vizualization') | capitalize }}
          </b-button>
          <b-button @click.prevent="toggleEditMode()" class="ml-3">
            <template v-if="spaceplan.isEditModeEnabled">
              <font-awesome-icon icon="check-circle" />
              {{ $t('done') | capitalize }}
            </template>
            <template v-else>
              <font-awesome-icon icon="pen" />
              {{ $t('edit') | capitalize }}
            </template>
          </b-button>
        </template>
      </b-col>
    </b-row>
    <user-share-modal
      ref="userShareModal"
      :title="$t('of-visualization')"
      :assignmentsGetFunc="getSpacePlanAssignments"
      :assignmentsDeleteFunc="deletePlanAssignment"
      :assignments-create-func="createPlanAsssignment"
    />
  </div>
</template>

<script>
import axios from 'axios';
import { mapActions, mapGetters, mapState } from 'vuex';
import BaseContextMenuMixin from '@/components/context-menus/BaseContextMenu';
import eventBus from '@/components/utils/slideout-panel/eventBus';
import UserShareModal from '@/components/sharing/userShareModal.vue';
import config from '@/config';


export default {
  name: 'Spaceplan',
  components: { UserShareModal },
  mixins: [
    BaseContextMenuMixin,
  ],
  computed: {
    ...mapGetters([
      'getSpaceplanById',
    ]),
    ...mapState('app', [
      'spaceplan',
    ]),
    getSpacePlanId() {
      return this.$route.params.id;
    },
    hasUserWritePermission() {
      const spaceplan = this.getSpaceplanById(this.getSpacePlanId);
      if (!spaceplan) {
        return false;
      }
      return this.$_.includes(spaceplan.permissions, 'w');
    },
  },
  methods: {
    ...mapActions('app', [
      'setState',
    ]),
    toggleEditMode() {
      const isEditModeEnabled = !this.spaceplan.isEditModeEnabled;
      this.setState({ section: 'spaceplan', setting: { isEditModeEnabled } });
    },
    addSpacePlanItemClicked() {
      eventBus.$emit('addSpacePlanItemClicked');
    },
    editSpacePlanClicked() {
      eventBus.$emit('editSpacePlanClicked');
    },
    shareClicked() {
      this.$refs.userShareModal.show();
    },
    removeSpacePlanClicked() {
      eventBus.$emit('removeSpacePlanClicked');
    },
    getSpacePlanAssignments() {
      const url = new URL(
        config.ICOOL.API.SPACEPLAN_ASSIGNMENTS_PATH(this.getSpacePlanId),
        config.ICOOL.BACKEND_HOST,
      ).href;
      return new Promise((resolve, reject) => {
        axios
          .get(url)
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            console.log(error);
            reject();
          });
      });
    },
    deletePlanAssignment(assignmentId) {
      const url = new URL(
        config.ICOOL.API.SPACEPLAN_ASSIGNMENT_PATH(this.getSpacePlanId, assignmentId),
        config.ICOOL.BACKEND_HOST,
      ).href;
      return new Promise((resolve, reject) => {
        axios
          .delete(url)
          .then((response) => {
            resolve();
          })
          .catch((error) => {
            console.log(error);
            reject();
          });
      });
    },
    createPlanAsssignment(userId, permissions) {
      const url = new URL(
        config.ICOOL.API.SPACEPLAN_ASSIGNMENTS_PATH(this.getSpacePlanId),
        config.ICOOL.BACKEND_HOST,
      ).href;
      return new Promise((resolve, reject) => {
        axios
          .post(url, { user: userId, permissions, spaceplan: this.getSpacePlanId })
          .then((response) => {
            resolve();
          })
          .catch((error) => {
            console.log(error);
            reject();
          });
      });
    },
  },
  created() {
    this.setState({ section: 'spaceplan', setting: { isEditModeEnabled: false } });
  },
};
</script>

<style scoped>

</style>
